/**
 * File generated based on swagger configuration. Do not edit.
 */
/* tslint:disable:no-reserved-keywords */
/* tslint:disable:class-name */
import {Express} from 'express';

export class BodyCardTypeCardNumber {
    public 'cardType': string;
    public 'cardNumber': string;

    constructor(partial?: Partial<BodyCardTypeCardNumber>) {
        
        Object.assign(this, partial);
    }
}

/**
* }
*/
export class BodyEmailPasswordBannerSourceApplication {
    public 'email': string;
    public 'password': string;
    public 'banner': string;
    public 'sourceApplication': string;

    constructor(partial?: Partial<BodyEmailPasswordBannerSourceApplication>) {
        
        Object.assign(this, partial);
    }
}

export class BodyBanner {
    public 'banner': string;

    constructor(partial?: Partial<BodyBanner>) {
        
        Object.assign(this, partial);
    }
}

export class BodyPortalToken {
    public 'portalToken': string;

    constructor(partial?: Partial<BodyPortalToken>) {
        
        Object.assign(this, partial);
    }
}

export class BodyRefreshTokenBanner {
    public 'refreshToken': string;
    public 'banner': string;

    constructor(partial?: Partial<BodyRefreshTokenBanner>) {
        
        Object.assign(this, partial);
    }
}

export class BodyEmailPasswordNewPasswordBanner {
    public 'email': string;
    public 'password': string;
    public 'newPassword': string;
    public 'banner': string;

    constructor(partial?: Partial<BodyEmailPasswordNewPasswordBanner>) {
        
        Object.assign(this, partial);
    }
}

export class BodyEmailBanner {
    public 'email': string;
    public 'banner': string;

    constructor(partial?: Partial<BodyEmailBanner>) {
        
        Object.assign(this, partial);
    }
}

export class ClubCardUser {
    public 'firstName': string;
    public 'lastName': string;
    public 'email': string;
    public 'password': string;
    public 'securityQuestion': SecurityQuestion;
    public 'securityAnswer': string;
    public 'clubCard': string;
    public 'agreedToMarketing': boolean;
    public 'phone': string;
    public 'title': string;
    public 'banner': string;

    constructor(partial?: Partial<ClubCardUser>) {
        
        Object.assign(this, partial);
    }
}

export class ClubCardUserResponse {
    public 'token': string;
    public 'refresh': string;
    public 'status': string;
    public 'userId': string;

    constructor(partial?: Partial<ClubCardUserResponse>) {
        
        Object.assign(this, partial);
    }
}

export class EmailSearch {
    public 'email': string;
    public 'banner': string;

    constructor(partial?: Partial<EmailSearch>) {
        
        Object.assign(this, partial);
    }
}

export class EmailSearchResult {
    public 'status': EmailSearchResult.StatusEnum;
    public 'roles': string[];
    public 'firstName': string;
    public 'lastName': string;

    constructor(partial?: Partial<EmailSearchResult>) {
        
        Object.assign(this, partial);
    }
}

export namespace EmailSearchResult {
    export enum StatusEnum {
        REGISTERED = <any>'REGISTERED',
        PARTIAL_REGISTERED = <any>'PARTIAL_REGISTERED',
        NOT_REGISTERED = <any>'NOT_REGISTERED'
    }
}

export class HybrisUser {
    public 'bannerID': string;
    public 'customerID': string;
    public 'firstName': string;
    public 'lastName': string;
    public 'dateOfBirth': string;
    public 'emailAddress': string;
    public 'phoneNumbers': HybrisuserPhoneNumbers[];
    public 'roles': HybrisuserRoles[];

    constructor(partial?: Partial<HybrisUser>) {
        
        Object.assign(this, partial);
    }
}

export class HybrisuserPhoneNumbers {
    public 'phoneNumber': string;
    public 'phoneNumberKind': string;

    constructor(partial?: Partial<HybrisuserPhoneNumbers>) {
        
        Object.assign(this, partial);
    }
}

export class HybrisuserRoles {
    public 'roleID': string;

    constructor(partial?: Partial<HybrisuserRoles>) {
        
        Object.assign(this, partial);
    }
}

export class InlineCodeMessage {
    public 'code': string;
    public 'message': string;

    constructor(partial?: Partial<InlineCodeMessage>) {
        
        Object.assign(this, partial);
    }
}

export class InlineError {
    public 'error': string;

    constructor(partial?: Partial<InlineError>) {
        
        Object.assign(this, partial);
    }
}

export class Search {
    public 'email': string;
    public 'clubCard': string;
    public 'name': string;
    public 'banner': string;

    constructor(partial?: Partial<Search>) {
        
        Object.assign(this, partial);
    }
}

export class SearchResult {
    public 'status': SearchResult.StatusEnum;
    public 'fistName': string;
    public 'lastName': string;
    public 'phoneNumber': string;
    public 'requireTitle': boolean;

    constructor(partial?: Partial<SearchResult>) {
        
        Object.assign(this, partial);
    }
}

export namespace SearchResult {
    export enum StatusEnum {
        REGISTERED = <any>'REGISTERED',
        PARTIAL_REGISTERED = <any>'PARTIAL_REGISTERED',
        NOT_REGISTERED = <any>'NOT_REGISTERED'
    }
}

export class SecurityQuestion {
    public 'id': string;
    public 'text': string;

    constructor(partial?: Partial<SecurityQuestion>) {
        
        Object.assign(this, partial);
    }
}

export class SecurityQuestions {
    public 'securityQuestions': SecurityQuestion[];

    constructor(partial?: Partial<SecurityQuestions>) {
        
        Object.assign(this, partial);
    }
}

export class SetPasswordRequest {
    public 'userIdHash': string;
    public 'resetToken': string;
    public 'password': string;

    constructor(partial?: Partial<SetPasswordRequest>) {
        
        Object.assign(this, partial);
    }
}

export class SetPasswordResponse {
    public 'firstName': string;
    public 'lastName': string;
    public 'email': string;
    public 'banner': string;
    public 'loyaltyMember': boolean;
    public 'roles': string[];

    constructor(partial?: Partial<SetPasswordResponse>) {
        
        Object.assign(this, partial);
    }
}

export class Shopper {
    public 'id': string;
    public 'email': string;
    public 'firstName': string;
    public 'lastName': string;
    public 'phone': string;
    public 'allowSubstitutions': boolean;
    public 'password': string;
    public 'agreedToTermsAndConditions': boolean;
    public 'agreedToMarketing': boolean;
    public 'banner': string;

    constructor(partial?: Partial<Shopper>) {
        
        Object.assign(this, partial);
    }
}

export class SubscriptionRequest {
    public 'email': string;
    public 'banner': string;
    public 'firstName': string;
    public 'lastName': string;
    public 'preferredStoreId': number;

    constructor(partial?: Partial<SubscriptionRequest>) {
        
        Object.assign(this, partial);
    }
}

export class SubscriptionResponse {

    constructor(partial?: Partial<SubscriptionResponse>) {
        
        Object.assign(this, partial);
    }
}

export class UserAuth {
    public 'userId': string;
    public 'access_token': string;
    public 'token_type': string;
    public 'refresh_token': string;
    public 'expires_in': number;
    public 'scope': string;

    constructor(partial?: Partial<UserAuth>) {
        
        Object.assign(this, partial);
    }
}

export class UserRegisterResponse {
    public 'userId': string;
    public 'token': string;
    public 'refresh': string;
    public 'status': string;

    constructor(partial?: Partial<UserRegisterResponse>) {
        
        Object.assign(this, partial);
    }
}

export class Validate {
    public 'cardNumber': string;
    public 'email': string;
    public 'banner': string;

    constructor(partial?: Partial<Validate>) {
        
        Object.assign(this, partial);
    }
}

export class ValidateUser {
    public 'phoneNumber': string;
    public 'firstName': string;
    public 'lastName': string;
    public 'valid': boolean;
    public 'requireTitle': boolean;

    constructor(partial?: Partial<ValidateUser>) {
        
        Object.assign(this, partial);
    }
}

export interface IUserApiMockController {
    addLoyaltyCard(body: BodyCardTypeCardNumber,  ignore?: boolean): Promise<void>;
    changePassword(body: BodyEmailPasswordNewPasswordBanner,  ignore?: boolean): Promise<any>;
    completeRegistration(body: ClubCardUser,  ignore?: boolean): Promise<ClubCardUserResponse>;
    createSubscription(body: SubscriptionRequest,  ignore?: boolean): Promise<SubscriptionResponse>;
    findUser(body: Search,  ignore?: boolean): Promise<SearchResult>;
    findUserByEmail(body: EmailSearch,  ignore?: boolean): Promise<EmailSearchResult>;
    getProfile( ignore?: boolean): Promise<Shopper>;
    getSecurityQuestions( ignore?: boolean): Promise<SecurityQuestions>;
    login(body: BodyEmailPasswordBannerSourceApplication,  ignore?: boolean): Promise<UserAuth>;
    loginAsGuest(body: BodyBanner,  ignore?: boolean): Promise<UserAuth>;
    loginByPortalToken(body: BodyPortalToken,  ignore?: boolean): Promise<UserAuth>;
    loginByRefreshToken(body: BodyRefreshTokenBanner,  ignore?: boolean): Promise<UserAuth>;
    logout( ignore?: boolean): Promise<any>;
    registerUser(body: Shopper,  ignore?: boolean): Promise<UserRegisterResponse>;
    resetPassword(body: BodyEmailBanner,  ignore?: boolean): Promise<void>;
    setPassword(body: SetPasswordRequest,  ignore?: boolean): Promise<SetPasswordResponse>;
    updateHybrisUser(body: HybrisUser,  ignore?: boolean): Promise<HybrisUser>;
    validateUser(body: Validate,  ignore?: boolean): Promise<ValidateUser>;
}


export function UserApiMockSetup (expressApp: Express, controller: Partial<IUserApiMockController>|IUserApiMockController) {

    expressApp['PUT'.toLowerCase()]('/user/card'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request PUT /user/card');

        if (!controller['addLoyaltyCard']) {
            res.status(500).send('Not implemented');
        } else {
            controller['addLoyaltyCard'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/password'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/password');

        if (!controller['changePassword']) {
            res.status(500).send('Not implemented');
        } else {
            controller['changePassword'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/registration/complete'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/registration/complete');

        if (!controller['completeRegistration']) {
            res.status(500).send('Not implemented');
        } else {
            controller['completeRegistration'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/subscription'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/subscription');

        if (!controller['createSubscription']) {
            res.status(500).send('Not implemented');
        } else {
            controller['createSubscription'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/search'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/search');

        if (!controller['findUser']) {
            res.status(500).send('Not implemented');
        } else {
            controller['findUser'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/search/email'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/search/email');

        if (!controller['findUserByEmail']) {
            res.status(500).send('Not implemented');
        } else {
            controller['findUserByEmail'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['GET'.toLowerCase()]('/user'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {

        console.log('receiving request GET /user');

        if (!controller['getProfile']) {
            res.status(500).send('Not implemented');
        } else {
            controller['getProfile'](undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['GET'.toLowerCase()]('/user/security-questions/'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {

        console.log('receiving request GET /user/security-questions/');

        if (!controller['getSecurityQuestions']) {
            res.status(500).send('Not implemented');
        } else {
            controller['getSecurityQuestions'](undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/login'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/login');

        if (!controller['login']) {
            res.status(500).send('Not implemented');
        } else {
            controller['login'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/login/guest'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/login/guest');

        if (!controller['loginAsGuest']) {
            res.status(500).send('Not implemented');
        } else {
            controller['loginAsGuest'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/login/portal'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/login/portal');

        if (!controller['loginByPortalToken']) {
            res.status(500).send('Not implemented');
        } else {
            controller['loginByPortalToken'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/login/refresh'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/login/refresh');

        if (!controller['loginByRefreshToken']) {
            res.status(500).send('Not implemented');
        } else {
            controller['loginByRefreshToken'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/logout'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {

        console.log('receiving request POST /user/logout');

        if (!controller['logout']) {
            res.status(500).send('Not implemented');
        } else {
            controller['logout'](undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user');

        if (!controller['registerUser']) {
            res.status(500).send('Not implemented');
        } else {
            controller['registerUser'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/password/reset'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/password/reset');

        if (!controller['resetPassword']) {
            res.status(500).send('Not implemented');
        } else {
            controller['resetPassword'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/password/set'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/password/set');

        if (!controller['setPassword']) {
            res.status(500).send('Not implemented');
        } else {
            controller['setPassword'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['PUT'.toLowerCase()]('/user/hybris'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request PUT /user/hybris');

        if (!controller['updateHybrisUser']) {
            res.status(500).send('Not implemented');
        } else {
            controller['updateHybrisUser'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });

    expressApp['POST'.toLowerCase()]('/user/validate'.replace(/{(.*?)}/g, ':$1'), (req, res, next) => {
        const body = req.body;

        console.log('receiving request POST /user/validate');

        if (!controller['validateUser']) {
            res.status(500).send('Not implemented');
        } else {
            controller['validateUser'](body, undefined)
            .then(result => {
                res.status(200).json(result);
                next();
            }).catch(error => {
                res.status(500).send('Internal server error');
            });
        }
    });


}



// WEBPACK FOOTER //
// ./mock/api/edge/user/index.ts